import(/* webpackChunkName: "reactdatagrid" */ '@inovua/reactdatagrid-enterprise/index.css').then(() => {
})





// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/reactDataGrid.ts